<script setup lang="ts">
import type { IAiChatExchangeRate } from './types'
import { toCurrencyCode } from '../utils'
import { CurrencyIcon } from '~/components/ui/currency-icon'

const props = defineProps<{ item: IAiChatExchangeRate }>()
const { t } = useI18n()

const currencyCode = computed(() => toCurrencyCode(props.item.currency))
const url = computed(() => `/rates/${currencyCode.value}`)

const categoryLabel = computed(() =>
  props.item.category === 'average' ? t('common.average_rate') : props.item.category
)
</script>

<template>
  <NuxtLink :to="url" class="AiCard group">
    <div class="flex items-center gap-2">
      <CurrencyIcon :code="currencyCode" size="sm" />
      <div class="min-w-0 flex-1">
        <div class="truncate text-sm font-semibold text-gray-900 group-hover:text-blue-600">
          {{ item.currency }} / {{ item.base_currency }}
        </div>
        <div class="text-xs text-gray-500">{{ categoryLabel }}</div>
      </div>
    </div>
    <div class="mt-2 flex gap-4 text-sm">
      <div class="flex flex-col">
        <span class="text-xs text-gray-500">{{ $t('common.buy') }}</span>
        <span class="font-semibold text-green-600">{{ item.buy }}</span>
      </div>
      <div class="flex flex-col">
        <span class="text-xs text-gray-500">{{ $t('common.sell') }}</span>
        <span class="font-semibold text-red-500">{{ item.sell }}</span>
      </div>
    </div>
  </NuxtLink>
</template>
